import {
  actionCreator,
  CHANGE_PASSWORD_API,
  changePasswordActionTypes,
  checkHttpStatus,
  jsonApiHeader,
  showErrorMessage,
  showSuccessMessage,
  CHANGE_SUPERADMIN_PASSWORD_API,
} from '../constants/ApiConstants';
import { loginActionTypes as loginActionTypes1 } from '../../../modules/logins/constants/ApiConstants';
import { loginActionTypes as loginActionTypes2 , handleLogoutRedirect} from '../../../modules/PatientPortal/logins/constants/ApiConstants';
import Alert from 'react-s-alert';

// SAVE CHANGED PASSSWORD
export const changePassword = (formData) => {
  return (dispatch, getState) => {
    const currentState = getState();
    dispatch(actionCreator(changePasswordActionTypes.post_changePassword.REQUEST));
    let saveData = JSON.stringify(formData);
    fetch(`${CHANGE_PASSWORD_API}`, {
      method: 'PATCH',
      body: saveData,
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response) {
          dispatch(actionCreator(changePasswordActionTypes.post_changePassword.SUCCESS, response));
          if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
            showSuccessMessage(response.message);
          //   Alert.info("Password Updated successfully, Please <span id='loginLink' style='cursor: pointer; text-decoration: none; color: blue;'>login</span> with new password.",{
          //     position: 'bottom-right',
          //       effect: 'slide',
          //       html: true,
          //       timeout: 5000,
  
          //   }
          // );
            // setTimeout(function() {
            //   document.getElementById('loginLink').addEventListener('click', function() {
            //    // Navigate to login screen
            //     if(currentState.login.loginUserInfo.users3.userRoles.roleName === 'Client'){
            //       dispatch(actionCreator(loginActionTypes2.logout_user.SUCCESS));
            //       handleLogoutRedirect('/client-login');
            //     }else{
            //       dispatch(actionCreator(loginActionTypes1.logout_user.SUCCESS));
            //     }
                
            //   });
            // }, 100);
          } 
          else {
            showErrorMessage(response.message);
          }
        };
      })
      .catch(function(error) {
        console.log(error);
      });
  };
};

// SAVE CHANGED PASSSWORD
export const changeSuperadminPassword = (formData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(changePasswordActionTypes.post_changeSuperadminPassword.REQUEST));
    let saveData = JSON.stringify(formData);
    fetch(`${CHANGE_SUPERADMIN_PASSWORD_API}`, {
      method: 'PATCH',
      body: saveData,
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response) {
          dispatch(actionCreator(changePasswordActionTypes.post_changeSuperadminPassword.SUCCESS, response));
          if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
            showSuccessMessage(response.message);
          } else {
            showErrorMessage(response.message);
          }
        };
      })
      .catch(function(error) {
        console.log(error);
      });
  };
};



// WEBPACK FOOTER //
// ./src/components/changePassword/actions/changePasswordAction.js